export class ToastError extends Error {
    readonly type = 'ToastError';
    constructor(message: string) {
        super(message);
    }
}

export class ToastWarning extends Error {
    readonly type = 'ToastWarning';
    constructor(message: string) {
        super(message);
    }
}

export function isToastError(error: any): error is ToastError {
    return !!(error && error.type === 'ToastError');
}

export function isToastWarning(error: any): error is ToastWarning {
    return !!(error && error.type === 'ToastWarning');
}
